import { apiRequest } from "../util/apiUtils";

export const getTestimonialList = async (params) => {
  try {
    const res = await apiRequest("get", "admin/testimonial/list", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const changeTestimonialStatus = async (payload = {}) => {
  try {
    const res = await apiRequest("post", "admin/testimonial/status-change", {
      body: payload,
    });
    return res;
  } catch (err) {
    return err;
    throw err;
  }
};

export const deleteTestimonial = async (payload = {}) => {
  try {
    const res = await apiRequest("post", "admin/testimonial/delete", {
      body: payload,
    });
    return res;
  } catch (err) {
    return err;
    throw err;
  }
};

export const addTestimonial = async (params) => {
  try {
    const res = await apiRequest(
      params.id ? "post" : "post",
      params.id ? "admin/testimonial/edit" : "admin/testimonial/add",
      {
        body: { ...params },
      },
      "multipart/form-data"
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const testimonialDetails = async (params) => {
  try {
    const res = await apiRequest("get", `admin/testimonial/details/${params?.id}`, {});
    return res?.data;
  } catch (err) {
    return err;
  }
};
